// ════════════════════════════════════════════════════════════
// Administración — facturas a cobrar y facturas a pagar
// ════════════════════════════════════════════════════════════
import React, { useState } from 'react';
import { Box, Typography, Tabs, Tab } from '@mui/material';
import FacturasCobrar from '../components/FacturasCobrar';
import FacturasPagar from '../components/FacturasPagar';

export default function Administracion() {
  const [tab, setTab] = useState(0);
  return (
    <Box>
      <Typography variant="h4" sx={{ fontWeight: 600, mb: 3, fontSize: { xs: '1.5rem', md: '2rem' } }}>
        🧾 Administración
      </Typography>
      <Tabs value={tab} onChange={(_, v) => setTab(v)} sx={{ mb: 3 }} variant="scrollable" scrollButtons="auto">
        <Tab label="💰 Facturas a cobrar" />
        <Tab label="💸 Facturas a pagar" />
      </Tabs>
      {tab === 0 && <FacturasCobrar />}
      {tab === 1 && <FacturasPagar />}
    </Box>
  );
}
